module.exports = __webpack_public_path__ + "static/img/alpha.22f5f37.png";